// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toast_toast__DKvnV {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 50rem;
  min-width: 28rem;
  color: #ffffff;
  background-color: #015d8e;
  border-radius: 8px;
  padding: 1.3rem;
  margin-bottom: 1.5rem;
}
.Toast_toast__DKvnV .Toast_icon__359tO,
.Toast_toast__DKvnV .Toast_errorIcon__YU6VZ {
  background-color: #fff;
  height: 3rem;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20rem;
}
.Toast_toast__DKvnV .Toast_icon__359tO span,
.Toast_toast__DKvnV .Toast_errorIcon__YU6VZ span {
  font-size: 1.5rem;
  color: #4caf50;
}
.Toast_toast__DKvnV .Toast_errorIcon__YU6VZ span {
  font-size: 1.5rem;
  color: #b33434;
}
.Toast_toast__DKvnV .Toast_body__IISut {
  flex: 1 1;
  margin: 0 1rem;
}
.Toast_toast__DKvnV .Toast_body__IISut span {
  font-size: 12px;
}
.Toast_toast__DKvnV .Toast_body__IISut p {
  margin: 0;
}
.Toast_toast__DKvnV .Toast_close__Sq8qE {
  height: 2rem;
  width: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  background-color: #0b4b6d;
}
.Toast_toast__DKvnV .Toast_close__Sq8qE span {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/Toast.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCHY;EDIZ,yBCNgB;EDOhB,kBCCc;EDAd,eAAA;EACA,qBAAA;AADF;AAGE;;EAEE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AADJ;AAGI;;EACE,iBAAA;EACA,cAAA;AAAN;AAKI;EACE,iBAAA;EACA,cAAA;AAHN;AAOE;EACE,SAAA;EACA,cAAA;AALJ;AAOI;EACE,eAAA;AALN;AAQI;EACE,SAAA;AANN;AAUE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBC7CY;ED8CZ,eAAA;EACA,yBCtDmB;AD8CvB;AAUI;EACE,eAAA;AARN","sourcesContent":["@import '../../variables';\n\n.toast {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 50rem;\n  min-width: 28rem;\n  color: $white-color;\n  background-color: $secondary-color;\n  border-radius: $border-radius;\n  padding: 1.3rem;\n  margin-bottom: 1.5rem;\n\n  .icon,\n  .errorIcon {\n    background-color: #fff;\n    height: 3rem;\n    width: 3rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 20rem;\n\n    span {\n      font-size: 1.5rem;\n      color: #4caf50;\n    }\n  }\n\n  .errorIcon {\n    span {\n      font-size: 1.5rem;\n      color: #b33434;\n    }\n  }\n\n  .body {\n    flex: 1;\n    margin: 0 1rem;\n\n    span {\n      font-size: 12px;\n    }\n\n    p {\n      margin: 0;\n    }\n  }\n\n  .close {\n    height: 2rem;\n    width: 2rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: $border-radius;\n    cursor: pointer;\n    background-color: $secondary-dark-color;\n\n    span {\n      font-size: 14px;\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `Toast_toast__DKvnV`,
	"icon": `Toast_icon__359tO`,
	"errorIcon": `Toast_errorIcon__YU6VZ`,
	"body": `Toast_body__IISut`,
	"close": `Toast_close__Sq8qE`
};
export default ___CSS_LOADER_EXPORT___;
